export default "__VITE_ASSET__783a17d6__"